export default __webpack_public_path__ + "static/media/$350m.22d405e0.svg";